import React from "react";
import ModificarArticulo from "../../../components/ModificarArticulo/ModificarArticulo";

export default function ModificarArticulos(props) { 
    return (
        <div>
            <ModificarArticulo idArticulo={props.location.state.idArticulo} clasificacion={props.location.state.clasificacion} />
        </div>
    );
}